// utils/getUserSubFromUsername.ts

import { LEGACY_API } from '../config/api';

export const getUserSubFromUsername = async (username: string, idToken: string): Promise<string | null> => {
  try {
    const response = await fetch(LEGACY_API.COGNITO_AUTH, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify({
        Operation: 'getUserSubByUsername',
        username: username
      })
    });
    const data = await response.json();
    return data.userSub || null;
  } catch (error) {
    console.error('Error getting userSub from username:', error);
    return null;
  }
};



export const getUserSubFromUsernameOpenEndpoint = async (username: string): Promise<string | null> => {
    try {
      const response = await fetch(LEGACY_API.USERPROFILE_OPEN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Operation: 'getUserSubByUsername',
          username: username
        })
      });
      const data = await response.json();
      return data.userSub || null;
    } catch (error) {
      console.error('Error getting userSub from username:', error);
      return null;
    }
  };